import api from "@/services";

export function fetchDashboard(perfil) {
  return api.get(`/dashboard/${perfil}`);
}
